/**
 * Cart token creations currently in flight. A depth counter rather than a
 * flag, because `cart/connect` can overlap and nests into itself on the guest
 * bypass, and only its own call site can clear it when a creation rejects.
 */
export const creating = { count: 0 }
